import React from "react";
import * as Provider from "../util/provider";

import * as Render from "../util/Render";
import * as Util from "../util/util";
import VLComponent from "../views/VLComponent";

class MatrixView extends VLComponent {

    constructor() {
        super();
        this.state = {columns: 4, images: []};
    }

    render() {
        return (
            <div style={{display: "flex", flexWrap: "wrap"}}>
                {this.props.images.map(this.renderSystem)}
            </div>
        );
    }

    renderSystem = (image) => {
        return (
            <div style={{width: (100 / this.props.columns) + "%"}}>
                <div style={{
                    margin: 8,
                    marginTop: 0,
                    borderRadius: 16,
                    background: image.background,
                    color: "white",
                    overflow: "hidden",
                    height: "calc(" + (100 / this.props.columns * 10 / 16) + "vw - 16px)",
                    position: "relative"
                }} onClick={image.onClick}>
                    {image.type != "sensor" ? this.renderCamera(image) : this.renderSensor(image)}
                    {image.overlay ? Render.overlay(image.overlay, "rgba(255,0,0,0.5)", null, null, 48) : []}
                </div>
            </div>
        );
    };

    renderSensor = (sensor) => {
        return (
            <div
                style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
                <div style={{display: "flex", width: "100%", alignItems: "center", padding: "0 12px"}}>
                    <p style={{textAlign: "center", flex: 1, marginLeft: 30}}>
                        <b>{sensor.title}</b>
                    </p>
                    <i className="material-icons">{sensor.mutli_image ? "add_to_photos" : ""}</i>
                </div>
                <div style={{flex: 1, width: "100%"}}>
                    {this.renderInfo(sensor)}
                </div>
            </div>
        );
    };

    renderInfo = (sensor) => {
        let scale = 0.2 / this.props.columns;

        const makeInfo = (name, level, en) => {
            return `${name} level: ${(en && level > 0) ? `${Util.round3(level)}m` : "Disabled"}`;
        };

        let infos = [`Level Change ${Util.round3(sensor.level_change)}m`, ""];

        if (sensor.provider != Provider.VL) {
            infos.push(`Warning Level ${Util.round3(sensor.warning_level)}m`);
            infos = infos.concat(["", `Max Level (24h) ${sensor.level_max}m`, ""]);
        } else if (Util.isCommunity()) {
            infos = infos.concat([`Max Level (24h) ${sensor.level_max}m`, `Avg Level (24h) ${sensor.level_avg}m`]);
        } else {
            infos = infos.concat([
                makeInfo(Util.actConLevelName(), sensor.act_con_level, sensor.fido_alarms_en),
                makeInfo(Util.alertLevelName(), sensor.alert_level, sensor.fido_alarms_en),
                makeInfo(Util.warningLevelName(), sensor.alert_level, sensor.warning_level),
                makeInfo("Smartphone", sensor.smartphone_warning, sensor.smartphone_warning_en)
            ]);
        }
        return <div style={{
            textAlign: "center",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: infos.length < 4 ? "space-around" : "space-between",
            paddingBottom: 8
        }}>
            <p style={{fontWeight: 700, fontSize: 20 * scale + "vw", margin: 0}}>
                Current Level {sensor.current_level}m
            </p>
            {infos.map(e => <p style={{fontSize: 16 * scale + "vw", margin: 0}}>{e}</p>)}
        </div>;
    };

    renderCamera = (camera) => {
        return (
            <div
                style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
                <div style={{display: "flex", width: "100%", alignItems: "center", padding: "0 12px"}}>
                    <p style={{textAlign: "center", flex: 1, marginLeft: 30}}>
                        <b>{camera.title}</b>
                    </p>
                    <i className="material-icons">{camera.mini_icon}</i>
                </div>
                <div style={{
                    backgroundImage: "url(" + camera.url + ")",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    flex: 1,
                    width: "100%"
                }}/>
            </div>
        );
    };

}

export default MatrixView;
